import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { CalendarCheck, ShoppingCart, ChefHat, Check, Gift, BookOpen, ClipboardList, Sparkles } from 'lucide-react';
export function BonusSection() {
  const scrollToOffer = () => {
    const el = document.getElementById('oferta');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    number: 1,
    icon: CalendarCheck,
    iconColor: 'text-[#1565C0]',
    iconBg: 'bg-[#E3F2FD]',
    accentColor: 'border-[#1565C0]',
    badgeBg: 'bg-[#1565C0]',
    title: '"El Sistema Domingo en 20 Minutos"',
    value: '$17.00 USD',
    image: 'https://cdn.magicpatterns.com/uploads/8NKPSnJEB22KAkyZPYetiW/bonoplannerdomingo.png',
    intro: '¿Cuántas veces llegaste al lunes sin idea de qué cocinar? Este sistema te enseña a planificar 7 días completos de comidas en una sola sesión de 20 minutos los domingos. Sin improvisar. Sin el "¿qué le doy hoy?" a las 12 del mediodía.',
    features: ['El framework "4-2-1" para sumar variedad sin pelea', 'Planner semanal imprimible + versión editable', 'Plantilla de rotación de 4 semanas', 'Checklist de 20 minutos para pegar en la heladera', 'Plan B anti-rechazo para días caóticos']
  }, {
    number: 2,
    icon: ShoppingCart,
    iconColor: 'text-[#2E7D32]',
    iconBg: 'bg-[#E8F5E9]',
    accentColor: 'border-[#2E7D32]',
    badgeBg: 'bg-[#2E7D32]',
    title: '"Lista de Supermercado Anti-Ultraprocesados"',
    value: '$12.00 USD',
    image: 'https://cdn.magicpatterns.com/uploads/5QRfqf6mfdLnMEJ9QeBZmF/mocklistasuper.png',
    intro: 'El súper es el lugar donde se rompe todo. Llegás con buenas intenciones y salís con lo mismo de siempre — porque estás cansada, apurada y las góndolas están diseñadas para tentarte. Esta lista te da una hoja de ruta por pasillos para entrar, comprar y salir en tiempo récord — con comida real y sin caer en ultraprocesados por cansancio.',
    features: ['Lista organizada pasillo por pasillo (súper argentino típico)', 'Guía de sustituciones: "si no hay X, comprá Y"', 'Mini-guía para leer etiquetas en 20 segundos', 'Plantilla por 3 niveles de presupuesto (Ajustado / Normal / Completo)', 'Lista de meriendas reales para no caer en paquetes', 'Versión móvil para llevar en el celu']
  }, {
    number: 3,
    icon: ChefHat,
    iconColor: 'text-[#6A1B9A]',
    iconBg: 'bg-[#F3E5F5]',
    accentColor: 'border-[#6A1B9A]',
    badgeBg: 'bg-[#6A1B9A]',
    title: '"Guía Mini-Chefs: Estrategia de Exposición"',
    value: '$18.00 USD',
    image: 'https://cdn.magicpatterns.com/uploads/q9dpGpwomS1FaZUPoTMJ9T/mockminichefs.png',
    intro: 'Si tu hijo rechaza todo lo nuevo, el problema no empieza en el plato. Empieza antes. La Guía Mini-Chefs te enseña a usar micro-tareas de 3 minutos en la cocina para que tu hijo se exponga a nuevos alimentos sin presión, sin berrinche y sin obligarlo. No es para que cocine. Es para que toque, huela y se familiarice — y eso solo ya baja el rechazo.',
    features: ['El Mapa de Progreso (mirar → tocar → oler → probar)', 'Tareas por edad (1–2 / 3–4 / 5–7 años)', 'Scripts exactos para invitar sin presión y responder al "NO"', 'Plan de exposición de 7 días + tabla de seguimiento', '12 "Misiones Mini-Chefs" listas para usar', 'Checklist imprimible']
  }];
  return <section className="py-16 px-4 bg-gradient-to-b from-white to-[#FFF8F0]" data-id="element-42">
      <div className="max-w-lg md:max-w-3xl mx-auto" data-id="element-43">
        {/* Section intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-44">
          <div className="inline-flex items-center gap-2 bg-[#FFF3E0] px-4 py-2 rounded-full mb-6 border border-[#FFE0B2]" data-id="element-45">
            <Gift className="w-5 h-5 text-[#E65100]" data-id="element-46" />
            <span className="text-[#E65100] font-bold text-sm uppercase tracking-wider" data-id="element-47">
              Bonos exclusivos
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-48">
            Pero eso no es todo.
          </h2>
          <div className="max-w-xl mx-auto space-y-4 text-gray-700 text-lg" data-id="element-49">
            <p data-id="element-50">
              Cuando decidí crear NutriPeques, sabía que una guía de recetas
              sola no alcanzaba.
            </p>
            <p data-id="element-51">
              Porque el problema no es solo <em data-id="element-52">qué cocinar</em>.
            </p>
            <p data-id="element-53">
              Es el domingo a las 8pm sin idea de qué darle la semana. Es el
              súper donde terminás agarrando lo mismo de siempre. Es cuando te
              pide un alfajor y no tenés ninguna alternativa real. Es la cara de
              asco que pone cuando ve algo nuevo en el plato.
            </p>
            <p className="font-bold text-gray-900 text-xl" data-id="element-54">
              Por eso hoy, junto con NutriPeques, te llevas{' '}
              <span className="text-[#E65100]" data-id="element-55">3 bonos de regalo</span> que
              resuelven exactamente eso.
            </p>
          </div>
        </motion.div>

        {/* Bonus cards */}
        <div className="space-y-8 mb-16" data-id="element-56">
          {bonuses.map((bonus, idx) => {
          const IconComponent = bonus.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.1
          }} className={`bg-white rounded-3xl shadow-lg overflow-hidden border-l-4 ${bonus.accentColor}`} data-id="element-57">
                {/* Card header */}
                <div className="p-6 md:p-8" data-id="element-58">
                  <div className="flex items-center gap-3 mb-2" data-id="element-59">
                    <div className={`${bonus.iconBg} p-2.5 rounded-xl`} data-id="element-60">
                      <IconComponent className={`w-6 h-6 ${bonus.iconColor}`} data-id="element-61" />
                    </div>
                    <span className={`${bonus.badgeBg} text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider`} data-id="element-62">
                      Bono #{bonus.number} — Gratis hoy
                    </span>
                  </div>

                  <h3 className="text-2xl font-black text-gray-900 mb-1 mt-4" data-id="element-63">
                    {bonus.title}
                  </h3>
                  <p className="text-sm text-gray-500 mb-6" data-id="element-64">
                    Valorado en{' '}
                    <span className="line-through" data-id="element-65">{bonus.value}</span> —{' '}
                    <span className="font-bold text-[#4CAF50]" data-id="element-66">
                      Tuyo gratis hoy
                    </span>
                  </p>

                  {/* Image */}
                  <div className="flex justify-center mb-6" data-id="element-67">
                    <img src={bonus.image} alt={bonus.title} className="w-full max-w-xs md:max-w-sm h-auto rounded-2xl shadow-md" data-id="element-68" />
                  </div>

                  <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-69">
                    {bonus.intro}
                  </p>

                  {/* Features */}
                  <div className="bg-gray-50 rounded-2xl p-5" data-id="element-70">
                    <p className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-71">
                      <ClipboardList className="w-4 h-4 text-gray-500" data-id="element-72" />
                      Incluye:
                    </p>
                    <ul className="space-y-2.5" data-id="element-73">
                      {bonus.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-2.5" data-id="element-74">
                          <Check className="w-5 h-5 text-[#4CAF50] shrink-0 mt-0.5" data-id="element-75" />
                          <span className="text-gray-700" data-id="element-76">{feature}</span>
                        </li>)}
                    </ul>
                  </div>

                  <div className="mt-6 text-center" data-id="element-77">
                    <p className="font-bold text-gray-900" data-id="element-78">
                      Valor real:{' '}
                      <span className="line-through text-gray-400" data-id="element-79">
                        {bonus.value}
                      </span>{' '}
                      <span className="text-[#4CAF50] font-black" data-id="element-80">
                        — Hoy es tuyo gratis.
                      </span>
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Value summary table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden mb-12" data-id="element-81">
          <div className="bg-gray-900 text-white text-center py-4 px-4" data-id="element-82">
            <h3 className="text-lg font-bold flex items-center justify-center gap-2" data-id="element-83">
              <Sparkles className="w-5 h-5 text-[#FFB300]" data-id="element-84" />
              RESUMEN DEL VALOR DE LOS BONOS
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-85">
            {[{
            label: 'Bono #1 — Sistema Domingo en 20 Minutos',
            original: '$17.00',
            free: true
          }, {
            label: 'Bono #2 — Lista Anti-Ultraprocesados',
            original: '$12.00',
            free: true
          }, {
            label: 'Bono #3 — Guía Mini-Chefs',
            original: '$18.00',
            free: true
          }].map((row, idx) => <div key={idx} className="flex justify-between items-center p-4" data-id="element-86">
                <div className="flex items-center gap-2" data-id="element-87">
                  <Gift className="w-5 h-5 text-[#E65100] shrink-0" data-id="element-88" />
                  <span className="text-gray-700 font-medium" data-id="element-89">{row.label}</span>
                </div>
                <div className="flex items-center gap-2 shrink-0 ml-4" data-id="element-90">
                  <span className="text-gray-400 line-through text-sm" data-id="element-91">
                    {row.original}
                  </span>
                  <span className="bg-[#4CAF50] text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-92">
                    GRATIS
                  </span>
                </div>
              </div>)}
            <div className="flex justify-between items-center p-4 bg-gray-50" data-id="element-93">
              <span className="font-bold text-gray-900" data-id="element-94">
                VALOR TOTAL DE LOS BONOS
              </span>
              <span className="font-black text-gray-900 shrink-0 ml-4" data-id="element-95">
                $47.00 USD
              </span>
            </div>
            <div className="flex justify-between items-center p-4 bg-[#E8F5E9]" data-id="element-96">
              <span className="font-bold text-[#2E7D32]" data-id="element-97">
                LO QUE PAGÁS HOY POR ESTOS 3 BONOS
              </span>
              <span className="font-black text-[#2E7D32] text-xl shrink-0 ml-4" data-id="element-98">
                $0 USD
              </span>
            </div>
          </div>
        </motion.div>

        {/* Closing copy + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-99">
          <div className="max-w-xl mx-auto space-y-4 text-gray-700 text-lg mb-8" data-id="element-100">
            <p data-id="element-101">
              Todo lo que necesitás para transformar la alimentación de tu peque
              está acá.
            </p>
            <div className="flex flex-col items-center gap-2 text-gray-800 font-medium" data-id="element-102">
              <span className="flex items-center gap-2" data-id="element-103">
                <BookOpen className="w-5 h-5 text-[#4CAF50]" data-id="element-104" /> Las recetas
                base.
              </span>
              <span className="flex items-center gap-2" data-id="element-105">
                <CalendarCheck className="w-5 h-5 text-[#1565C0]" data-id="element-106" /> El sistema
                de planificación.
              </span>
              <span className="flex items-center gap-2" data-id="element-107">
                <ShoppingCart className="w-5 h-5 text-[#2E7D32]" data-id="element-108" /> La lista de
                compras inteligente.
              </span>
              <span className="flex items-center gap-2" data-id="element-109">
                <ChefHat className="w-5 h-5 text-[#6A1B9A]" data-id="element-110" /> La estrategia
                para bajar el rechazo.
              </span>
            </div>
            <p className="font-bold text-gray-900 text-xl" data-id="element-111">
              Un solo paquete. Un solo precio. Todo resuelto.
            </p>
            <p className="text-gray-600" data-id="element-112">
              Y si en 7 días no notás una diferencia real en la mesa — te
              devuelvo cada centavo. Sin preguntas.
            </p>
          </div>

          <button onClick={scrollToOffer} className="w-full max-w-md min-h-[64px] bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-lg md:text-xl font-bold rounded-2xl shadow-[0_6px_0_#1B5E20] hover:shadow-[0_3px_0_#1B5E20] hover:translate-y-1 transition-all px-6 py-4 mx-auto flex items-center justify-center gap-2" data-id="element-113">
            <Gift className="w-6 h-6" data-id="element-114" />
            Quiero NutriPeques + los 3 bonos gratis
          </button>
        </motion.div>
      </div>
    </section>;
}